'use strict';

import Api from "./Api";

export default class Trainer extends Api {

    static getList(page = 1, perPage = 10, sort = undefined) {
        const url = this.url + 'trainer/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
                sort: sort,
            },
        });
    }

    static get(id) {
        const url = this.url + 'trainer/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'trainer/add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'trainer/update';

        return this.getAxios().post(url, data);
    }

    static updateImage(id, file) {
        const url = this.url + 'trainer/upload-image';

        const form = new FormData();
        form.append('id', id);
        form.append('image', file);

        return this.getAxios().post(url, form);
    }

}